const Languages = Object.freeze({
  de: 'German',
  'en-150': 'English - Europe',
  'en-au': 'English - Australia',
  'en-ca': 'English - Canada',
  'en-gb': 'English - United Kingdom',
  'en-ie': 'English - Ireland',
  'en-nz': 'English - New Zealand',
  'en-us': 'English - United States',
  'es-419': 'Spanish - Latin America',
  'es-es': 'Spanish - Spain',
  fr: 'French',
  'fr-be': 'French - Belgium',
  'fr-ca': 'French - Canada',
  it: 'Italian',
  ja: 'Japanese',
  ko: 'Korean',
  nl: 'Dutch',
  'nl-be': 'Dutch - Belgium',
  pl: 'Polish',
  'pt-br': 'Portuguese - Brazil',
  'pt-pt': 'Portuguese - Portugal',
  ru: 'Russian',
  tr: 'Turkish',
  'zh-hans': 'Chinese - Simplified',
  'zh-hant': 'Chinese - Traditional',
});

export default Languages;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/answers/answer_languages.js